/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IStateService} from 'angular-ui-router';
import AuthServiceRS from '../../../authentication/service/AuthServiceRS.rest';
import {BemerkungDialogController} from '../../../core/dialog/BemerkungDialogController';
import {RemoveDialogController} from '../../../core/dialog/RemoveDialogController';
import {YesNoController} from '../../../core/dialog/YesNoController';
import {DvDialog} from '../../../core/directive/dv-dialog/dv-dialog';
import ErrorService from '../../../core/errors/service/ErrorService';
import RoleUtilService from '../../../core/service/RoleUtilService';
import SchadenfallModelManager from '../../../core/service/SchadenfallModelManager';
import StatuswechselService from '../../../core/service/StatuswechselService';
import {TSBegruendungsCode} from '../../../models/enums/TSBegruendungsCode';
import {TSBemerkungScope} from '../../../models/enums/TSBemerkungScope';
import {TSDocumentType} from '../../../models/enums/TSDokumentType';
import {TSRole} from '../../../models/enums/TSRole';
import {TSSchadenfallEvent} from '../../../models/enums/TSSchadenfallEvent';
import {TSSchadenfallStatus} from '../../../models/enums/TSSchadenfallStatus';
import TSEigenleistung from '../../../models/TSEigenleistung';
import TSEigenleistungDaten from '../../../models/TSEigenleistungDaten';
import TSFremdkosten from '../../../models/TSFremdkosten';
import TSFremdkostenDaten from '../../../models/TSFremdkostenDaten';
import TSSchadenfall from '../../../models/TSSchadenfall';
import TSStatuswechsel from '../../../models/TSStatuswechsel';
import TSVorleistung from '../../../models/TSVorleistung';
import TSVorleistungDaten from '../../../models/TSVorleistungDaten';
import DVBernUtil from '../../../utils/DVBernUtil';
import {IEigenleistungeStateParams, IFremdkostenStateParams, IVorleistungStateParams} from '../../gesuch.route';
import AbstractModelManagerController from '../abstractModelManagerController';
import IComponentOptions = angular.IComponentOptions;
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

declare let require: any;
declare let angular: any;

let styles = require('./aufwaendeView.scss');
let template = require('./aufwaendeView.html');
let removeDialogTemplate = require('../../../core/dialog/removeDialogTemplate.html');
let bemerkungDialogTemplate = require('../../../core/dialog/bemerkungDialogTemplate.html');
let yesNoTemplate = require('../../../core/dialog/yesNoTemplate.html');

export class AufwaendeViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = AufwaendeViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        schadenfall: '<',
        schaetzung: '<',
    };
}

export class AufwaendeViewController extends AbstractModelManagerController<TSSchadenfall> {
    static $inject = [
        'DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$translate', '$log', '$state',
        'DvDialog', 'StatuswechselService', 'AuthServiceRS', 'RoleUtilService', 'ErrorService',
    ];
    schadenfall: TSSchadenfall;
    schaetzung: boolean;
    aufwandForm: IFormController;
    scopeToShow: Array<TSBemerkungScope> = [];
    scope: TSBemerkungScope = TSBemerkungScope.AUFWAENDE;

    statuswechsel: TSStatuswechsel | undefined;
    checklistValid: boolean;
    schadenfallEvent: TSSchadenfallEvent | undefined;
    doctype: TSDocumentType;
    relevanteEigenleistungen: Array<TSEigenleistung> = [];
    relevanteFremdkosten: Array<TSFremdkosten> = [];
    relevanteVorleistungen: Array<TSVorleistung> = [];
    showSubventioniert: boolean;

    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil, schadenfallModelManager: SchadenfallModelManager,
                private $q: IQService,
                $scope: IScope, private $translate: ITranslateService, private $log: ILogService,
                private $state: IStateService, private dvDialog: DvDialog, private statuswechselService: StatuswechselService,
                private authServiceRS: AuthServiceRS, private roleUtilService: RoleUtilService, private errorService: ErrorService,
    ) {
        super(schadenfallModelManager, $scope, $state.current.name);

    }

    $onInit() {
        super.$onInit();

        if (!this.schadenfall) {
            console.error('no schadenfall passed to view');
        } else {
            this.initialModel = this.schadenfall;
            this.model = angular.copy(this.schadenfall);
        }

        if (!this.schadenfall.fremdkosten) {
            this.schadenfall.fremdkosten = [];
        }

        // Show only Bemerkungen from Scope Aufwände
        this.scopeToShow.push(TSBemerkungScope.AUFWAENDE);
        this.statuswechsel = this.statuswechselService.getStatuswechselMetadata(this.schadenfall.status, this.schadenfall.erfassungsart);

        this.initRelevantCollections();
        this.setShowSubventioniert();
        this.doctype = this.schaetzung ? TSDocumentType.SCHAETZUNG_DOC : TSDocumentType.AUFWAENDE_DOC;
    }

    public getSchadenName(index: string): string {
        return this.$translate.instant('SCHADEN') + ' ' + index;

    }

    public cancelFremdkosten() {
        this.resetView();
    }

    public addFremdkosten() {
        let newFremdkosten = this.createFremdkosten();
        let params: IFremdkostenStateParams;
        params = {
            schadenfallId: this.schadenfall.id,
            fremdkostenId: '',
            fremdkosten: newFremdkosten,
            schaetzung: String(this.schaetzung)
        };
        this.$state.go('fremdkosten', params);
    }

    public deleteFremdkosten(fremdkosten: TSFremdkosten, event: any): void {
        this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController, {
            text: '',
            title: 'AUFWAND_FREMDKOSTEN_REMOVE',
        }).then(() => {   //User confirmed removal
            this.schadenfallModelManager.removeFremdkosten(fremdkosten).then(() => {
                    this.initRelevantCollections();
                },
            );
        }).catch(() => {
        });
    }

    public editFremdkosten(fremdkosten: TSFremdkosten, event: any): void {
        let params: IFremdkostenStateParams;
        params = {
            schadenfallId: this.schadenfall.id,
            fremdkostenId: fremdkosten.id,
            fremdkosten: fremdkosten,
            schaetzung: String(this.schaetzung)
        };
        this.$state.go('fremdkosten', params);
    }

    public deleteEigenleistung(eigenleistung: TSEigenleistung, event: any): void {
        this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController, {
            text: '',
            title: 'EIGENLEISTUNG_LOESCHEN',
        }).then(() => {   //User confirmed removal
            this.schadenfallModelManager.removeEigenleistung(eigenleistung).then(() => {
                    this.initRelevantCollections();
                },
            );
        }).catch(() => {
        });

    }

    public editEigenleistung(eigenleistung: TSEigenleistung, event: any): void {
        let params: IEigenleistungeStateParams;
        params = {
            schadenfallId: this.schadenfall.id,
            eigenleistungId: eigenleistung.id,
            eigenleistung: eigenleistung,
            schaetzung: String(this.schaetzung)
        };
        this.$state.go('eigenleistungen', params);
    }

    public addEigenleistung() {
        let newEL = this.createEigenleistungen();
        let params: IEigenleistungeStateParams;
        params = {
            schadenfallId: this.schadenfall.id,
            eigenleistungId: '',
            eigenleistung: newEL,
            schaetzung: String(this.schaetzung)
        };
        this.$state.go('eigenleistungen', params);
    }

    public initRelevantCollections() {
        this.relevanteEigenleistungen = this.schadenfall.getRelevanteEigenleistungen(this.schaetzung);
        this.relevanteFremdkosten = this.schadenfall.getRelevanteFremdkosten(this.schaetzung);
        this.relevanteVorleistungen = this.schadenfall.getRelevanteVorleistungen(this.schaetzung);
    }

    public deleteVorleistung(vorleistung: TSVorleistung, event: any): void {

        this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController, {
            text: '',
            title: 'VORLEISTUNG_LOESCHEN',
        }).then(() => {   //User confirmed removal
            this.schadenfallModelManager.removeVorleistung(vorleistung).then(() => {
                    this.initRelevantCollections();
                },
            );
        }).catch(() => {
        });

    }

    public editVorleistung(vorleistung: TSVorleistung, event: any): void {
        let params: IVorleistungStateParams;
        params = {
            schadenfallId: this.schadenfall.id,
            vorleistungId: vorleistung.id,
            vorleistung: vorleistung,
            schaetzung: String(this.schaetzung)
        };
        this.$state.go('vorleistung', params);
    }

    public addVorleistung() {
        let newVorleistung = this.createVorleistung();
        let params: IVorleistungStateParams;
        params = {
            schadenfallId: this.schadenfall.id,
            vorleistungId: '',
            vorleistung: newVorleistung,
            schaetzung: String(this.schaetzung)
        };
        this.$state.go('vorleistung', params);
    }

    public getViewTitle(): string {
        return this.dvBernUtil.getViewTitle(this.schadenfall);
    }

    public isFreigabeVisible(): boolean {
        //maybe extract this out into service?
        if (this.statuswechsel !== undefined) {
            let hasAllowedRole = this.authServiceRS.isOneOfRoles(this.statuswechsel.allowedRoles);
            let isOnRelevantPage = this.statuswechsel.visibleOnPage === this.$state.current.name;
            return hasAllowedRole && isOnRelevantPage && this.getSchadenfallEvents().length !== 0
        }
        return false;
    }

    public getChecklistEntries(): Array<string> {
        if (this.statuswechsel !== undefined) {
            return this.statuswechsel.checklistOptions;
        }
        return [];
    }

    public getBegrundungscodeOptions(): Array<TSBegruendungsCode> {
        if (this.statuswechsel !== undefined) {
            if (this.schadenfallEvent === undefined) {
                console.warn('Should have selected schadenfallEvent to trigger, otherwise allowed begruendugnscodes will not be set)');
                return [];
            } else {
                return this.statuswechsel.readBegruendungscodeOptions(this.schadenfallEvent);
            }

        }
        return [];
    }

    public getSchadenfallEvents() {
        if (this.statuswechsel !== undefined) {
            return this.statuswechsel.possibleEvents;
        }
        return [];
    }

    public checklistStatusChanged(allchecked: boolean): void {
        this.checklistValid = allchecked;
        if (!this.checklistValid) {
            this.schadenfallEvent = undefined;
        }
    }

    public isFreigabeDisabled(): boolean {
        return this.checklistValid !== true;
    }

    public getRolesAllowedForBankdaten(): Array<TSRole> {
        return this.dvBernUtil.getRolesAllowedForBankdaten();
    }

    public isShowTitlePrefix(): boolean {
        return this.dvBernUtil.isShowTitlePrefix(this.schadenfall.gesuchsteller);
    }

    public isSchadenFallAbrechnenAuszahlen() {
        if (this.schadenfall.status) {
            return this.schadenfall.status === TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN ||
                this.schadenfall.status === TSSchadenfallStatus.AUSZAHLUNG;
        }
        return false;
    }

    public saveAufwaendeSchaden(): void {
        this.errorService.clearAll();
        if (this.schadenfall) {
            this.schadenfallModelManager.saveSchaden(this.model.schaeden[0]).then((schadenResp) => {
                this.initialModel.schaeden[0] = schadenResp;
                this.model.schaeden[0] = angular.copy(schadenResp);
                this.schadenfall.schaeden[0] = schadenResp;
            });

        }
    }

    public editBankkonto(): void {
        let params: any = {schadenfallId: this.schadenfall.id};
        this.$state.go('bankkonto', params);
    }

    public getBegleitTextCode() {
        return this.schaetzung ? 'UPLOAD_TEXT' : 'AUFAWENDE_DOC_BEGLEITTEXT';
    }

    public isGeschaetzteMassnahmenRequired() {
        return this.schadenfallModelManager.isStatusAbAuftragSchaetzer() || this.schadenfallModelManager.isStatusNeuPapierFS();
    }

    private resetView() {
        this.form.$setPristine();
        this.form.$setUntouched();

    }

    private createFremdkosten(): TSFremdkosten {
        let fremdkosten = new TSFremdkosten();
        fremdkosten.schaetzung = this.schaetzung;
        fremdkosten.fremdkostenDatenFS = new TSFremdkostenDaten();
        return fremdkosten;
    }

    private createEigenleistungen(): TSEigenleistung {
        let eigenleistungen = new TSEigenleistung();
        eigenleistungen.schaetzung = this.schaetzung;
        eigenleistungen.eigenleistungDatenFS = new TSEigenleistungDaten();
        return eigenleistungen;
    }

    private createVorleistung(): TSVorleistung {
        let vorleistung = new TSVorleistung();
        vorleistung.schaetzung = this.schaetzung;
        vorleistung.vorleistungDatenFS = new TSVorleistungDaten();
        return vorleistung;
    }

    private isInWiederherstellung(): boolean {
        return this.schadenfall.status === TSSchadenfallStatus.WIEDERHERSTELLUNG;
    }

    private isInUeberpruefungSchaetzer(): boolean {
        return this.schadenfall.status === TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER;
    }

    private isInAuftragOrUeberpruefungSchaetzer(): boolean {
        return this.schadenfall.status === TSSchadenfallStatus.AUFTRAG_SCHAETZER ||
            this.schadenfall.status === TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER;
    }

    private isInUeberpruefungAnlaufstelle(): boolean {
        return this.schadenfall.status === TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE;
    }

    private next() {
        this.errorService.clearAll();
        if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getSchaetzerRolesOnly()) && this.isInAuftragOrUeberpruefungSchaetzer()) {
            this.triggerSchaetzerFreigabe();
        } else if (this.isInWiederherstellung()) {
            this.transitWiederherstellung();
        } else if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getFondssuisseRoles()) &&
            (this.ueberpruefungFS() || this.isInStichentscheidFS() || this.isInBearbeitungASStichentscheidFS())) {
            //Ueberpruefung FS abschliessen
            this.triggerUeberpruefungFSDialog();
        } else if (this.isInUeberpruefungAnlaufstelle()) {
            this.triggerUeberpruefungAnlaufstelleDialog();
        } else {
            this.$log.info('no next state available for this fall in this role');
        }
    }

    private triggerSchaetzerFreigabe() {
        if (!this.areSchaedenValid()) {
            return;
        }
        if (this.isInUeberpruefungSchaetzer()) {

            // Aufwand vorhanden, aber kein Bankkonto
            if (this.hasAufwand() && !this.hasBankkonto()) {
                this.errorService.addMesageAsError('ERROR_NO_BANKKONTO_ENTERED')
                return;
            }

            // Fall: in Überprüfung, Aufwand vorhanden, Bankkonto vorhanden
            this.triggerSchaetzerFreigabeDialog();
            return;
        }

        // Fall: nicht in Überprüfung
        this.triggerSchaetzerFreigabeDialog();
    }

    private transitWiederherstellung() {
        if (!this.hasAufwand()) {
            const message = this.$translate.instant('ERROR_NO_LEISTUNG_ENTERED');

            this.dvDialog.showDialog(yesNoTemplate, YesNoController, {
                text: message,
                title: '',
            }).then(() => {
                this.triggerBetroffenerFreigabeDialog();
            });
            return;
        }
        if (!this.hasBankkonto()) {
            this.errorService.addMesageAsError('ERROR_NO_BANKKONTO_ENTERED')
            return;
        }

        this.triggerBetroffenerFreigabeDialog();
    }

    private hasAufwand() {
        return this.schadenfall.hasEigenleistungen() || this.schadenfall.hasFremdkosten() || this.schadenfall.hasVorleistungen();
    }

    private hasBankkonto() {
        const finanz = this.schadenfall.gesuchsteller.finanzangaben;
        return !!finanz &&
            !!finanz.finanzangabenDatenFS.bankverbindung &&
            !!finanz.finanzangabenDatenFS.bankverbindung.iban;
    }

    private hasNoSchaetzung(): boolean {
        //wenn keine Schaetzung vorhanden ist
        if (this.schadenfall.getAbrechnungsbetrag(true) === null ||
            this.schadenfall.getAbrechnungsbetrag(true) === undefined ||
            this.schadenfall.getAbrechnungsbetrag(true) === 0) {
            return true;
        }
        return false;
    }

    private areSchaedenValid(): boolean {
        if (this.schadenfall.schaeden.filter(
            schaden => schaden.schadenDatenFS.vorgeseheneMassnahmen === null ||
                schaden.schadenDatenFS.vorgeseheneMassnahmen === undefined).length > 0) {
            //wenn min ein Schaden keinen Beschrieb hat Fehler anzeigen
            this.errorService.addMesageAsError('ERROR_NO_SCHADEN_VORGESEHENE_MASSNAHMEN');
            return false;
        }
        if (this.schadenfall.schaeden.filter(
            schaden => schaden.schadenDatenFS.otherwieseSubventionierbar === null ||
                schaden.schadenDatenFS.otherwieseSubventionierbar === undefined).length > 0) {
            //wenn min ein Schaden kein subventioniert flag hat Fehler anzeigen
            this.errorService.addMesageAsError('ERROR_NO_SUBVENTIONIERT_FLAG');
            return false;
        }

        // further checks are removed, see FS-653
        return true;
    }

    private triggerSchaetzerFreigabeDialog() {
        if (this.hasNoSchaetzung()) {
            //Warnung, wenn keine Schaetzung (Abrechnungsbetrag) vorhanden ist
            this.freigabeDialogWithWarning()
        } else {
            this.freigabeDialogWithoutWarning();
        }
    }

    private freigabeDialogWithoutWarning() {

        this.dvDialog.showBemerkungDialog(bemerkungDialogTemplate, BemerkungDialogController, {
            text: this.schadenfallEvent,
            begrundungscodeOptions: this.getBegrundungscodeOptions(),
            showBegruendung: true,
            showBemerkung: true,
        }).then((response) => {
            if (response && this.schadenfallEvent) {
                this.saveAufwaendeSchaden();
                this.schadenfallModelManager.handleTransition(this.schadenfall, TSBemerkungScope.AUFWAENDE, response.begruendung,
                    response.bemerkung, this.schadenfallEvent)
                    .then(() => {
                        this.$state.go('schadenfaelle');
                    });
            }
        }).catch(() => {
        });
    }

    private freigabeDialogWithWarning() {
        const message = this.$translate.instant('ERROR_NO_SCHAETZUNG');

        this.dvDialog.showDialog(yesNoTemplate, YesNoController, {
            text: message,
            title: '',
        }).then(() => {
            if (this.schadenfallEvent) {
                this.saveAufwaendeSchaden();
                this.schadenfallModelManager.handleTransition(this.schadenfall,
                    TSBemerkungScope.AUFWAENDE,
                    undefined,
                    '',
                    this.schadenfallEvent)
                    .then(() => {
                        this.$state.go('schadenfaelle');
                    });
            }
        }).catch(() => {
        })
    }

    private triggerBetroffenerFreigabeDialog() {
        this.dvDialog.showBemerkungDialog(bemerkungDialogTemplate, BemerkungDialogController, {
            text: 'FREIGABE_BEMERKUNG_GESUCHSTELLER_TEXT',
            showBegruendung: false,
            showBemerkung: false,
        }).then((response) => {
            if (response && this.schadenfallEvent) {
                this.saveAufwaendeSchaden();
                this.schadenfallModelManager.handleTransition(this.schadenfall, TSBemerkungScope.AUFWAENDE, response.begruendung,
                    response.bemerkung, this.schadenfallEvent)
                    .then((response) => {
                        this.$state.go('schadenfaelle');
                    });
            }
        }).catch(() => {
        });
    }

    private triggerUeberpruefungAnlaufstelleDialog() {
        this.triggerGenericFreigabeDialog();
    }

    private triggerUeberpruefungFSDialog() {
        this.triggerGenericFreigabeDialog();
    }

    private triggerGenericFreigabeDialog(params?: any) {
        //use passed params or init default
        let dialogParams = params || {
            text: this.schadenfallEvent,
            begrundungscodeOptions: this.getBegrundungscodeOptions(),
            showBegruendung: true,
            showBemerkung: true,
        };
        this.dvDialog.showBemerkungDialog(bemerkungDialogTemplate, BemerkungDialogController, dialogParams).then((response: any) => {
            if (response && this.schadenfallEvent) {
                this.saveAufwaendeSchaden();
                this.schadenfallModelManager.handleTransition(this.schadenfall, TSBemerkungScope.AUFWAENDE, response.begruendung,
                    response.bemerkung, this.schadenfallEvent)
                    .then((response: any) => {
                        this.resetView();
                        this.$state.go('schadenfaelle');
                    });
            }
        }).catch(() => {
        });
    }

    private setShowSubventioniert(): void {
        this.showSubventioniert =
            this.schaetzung &&
            (this.schadenfallModelManager.isStatusAbAuftragSchaetzer() || this.schadenfallModelManager.isStatusNeuPapierFS());
    }

    private ueberpruefungFS(): boolean {
        return this.schadenfall.status === TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE;
    }

    private isInStichentscheidFS(): boolean {
        return this.schadenfall.status === TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS;
    }

    private isInBearbeitungASStichentscheidFS(): boolean {
        return this.schadenfall.status === TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS;
    }
}



// WEBPACK FOOTER //
// ./src/app/gesuch/component/aufwaendeView/aufwaendeView.ts